import { render, staticRenderFns } from "./FileUploadSingle.vue?vue&type=template&id=24bce616&scoped=true"
import script from "./FileUploadSingle.vue?vue&type=script&lang=js"
export * from "./FileUploadSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24bce616",
  null
  
)

export default component.exports